<template>
  <div class="redetail-char" @click="rechartm" id="bar">
    <!-- -->
    <h3 class="title">指标曲线</h3>

    <template v-if="getauthoritybo">
      <div class="u-flex u-row-between">
        <div class="u-flex">
          <div class="chart-left">选择指标</div>
          <div style="min-width: 300px; max-width: 400px; position: relative">
            <Cselcet
              @change="optenChange(false)"
              :maxTag="2"
              :data="chatsList"
              clable="label"
              cvalue="value"
              v-model="list"
              ref="selcet"
              @on-select="changeTag"
              :max="5"
              @click="Selectmetrics"
            />
          </div>
          <!-- <Select  :disabled="selectIsBo" @on-select="changeTag" :max-tag-count="2" v-model="list" multiple style="min-width:300px;max-width:400px;position: relative;">
          <Option v-for="item in chatsList" :value="item.value" :key="item.value">{{ item.label }}</Option>
        </Select> -->
          <Button
            type="primary"
            style="margin-left: 10px"
            @click="optenChange(false)"
            :disabled="ccstataShow"
            >查询</Button
          >
        </div>
        <div class="chart-right u-flex">
          <div class="u-flex"></div>
        </div>
        <div
          class="u-flex char-statistics pot"
          @click.stop="statissShowmethods"
        >
          <div class="stat-left" v-html="FormData.text"></div>
          <div class="pot pot-static-width">
            <Icon type="ios-arrow-down pot-static-width" />
          </div>
          <Statticdro
            :len="list.length"
            :m5coption="m5coption"
            :dataOptions="dataOptions"
            :statcCityOtiopn="statcCityOtiopn"
            :btns="btns"
            :FormData="FormData"
            :chartForm="chartForm"
            v-model="ccstataShow"
            @change="statuMethods"
          />
        </div>
      </div>

      <!-- isEmtey -->
      <div class="u-rel chartop">
        <div class="uax pot" @click="shuaxecharts">
          <Tooltip
            theme="light"
            placement="right"
            trigger="hover"
            content="刷新曲线"
          >
            <img src="@/assets/images/resx.png" class="pot imgshuax" alt="" />
          </Tooltip>
        </div>
        <div
          class="rhdetiChat"
          :class="{ blurback: this.isEmtey }"
          :id="`rhdetiChat${index}`"
        ></div>

        <div class="blur" v-if="this.isEmtey && !this.btns.invalid">
          <Icon type="ios-alert-outline" size="20" color="#000" />
          <div class="emtifont">暂无数据</div>
        </div>

        <div class="axis-tip"></div>
        <div class="axis-btns">
          <div
            v-show="index.bo"
            :key="key"
            v-for="(index, key) in yAxistbns"
            :style="{ left: `${index.left}px` }"
            class="axis-btn"
            @click="btnclick(index, key)"
          >
            <img
              src="@/assets/images/ruler.png"
              class="pot"
              style="width: 16px; height: 16px"
            />
          </div>
        </div>
      </div>

      <template>
        <div class="right-btns" style="padding-left: 15px" v-if="banbtnbo > 0">
          <div>
            <div class="u-flex">
              <div class="newRadio">
                <Radio
                  v-model="btns.invalid"
                  :disabled="datastacsbo || isbtn.invalid || ccstataShow "
                  style="font-size: 12px"
                >
                  <span :class="{ 'radio-dis': datastacsbo ||ccstataShow }">显示无效值</span>
                </Radio>
                <div
                  class="ridos"
                  :class="{ 'radio-dis': datastacsbo ||ccstataShow }"
                  @click="radiomthInvalid()"
                ></div>
              </div>
              <div class="righ-btn no-opt" v-if="banbtnbo > 1 || !btns.invalid ">
                <div class="u-flex btn-marin">
                  <img
                    src="@/assets/images/bdbj-icon.png"
                    width="12px"
                    height="12px"
                    style="margin-right: 4px"
                  />

                  全部质量位
                  <Icon type="ios-arrow-down" />
                </div>
              </div>
              <Dropdown v-else>
                <div
                  class="righ-btn pot btn-marin"
                  :class="{ 'btn-click': btns.invalid  }"
                >
                  <img
                    src="@/assets/images/taiz.png"
                    width="14px"
                    height="12px"
                    style="margin-right: 4px"
                  />
                  {{ markText }}
                  <Icon type="ios-arrow-down" />
                </div>
                <DropdownMenu slot="list">
                  <a
                    href="javascript:;"
                    @click="imaginary(vol)"
                    v-for="(vol, key) in markOption"
                    :key="key"
                  >
                    <DropdownItem>
                      {{ vol.label }}
                    </DropdownItem>
                  </a>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <div class="u-flex right-margin">
            <template>
              <div class="u-flex">
                <!--  -->
                <div
                  v-if="btns.monotonicity && slopobj"
                  class="shar-card"
                  style="margin-right: 10px"
                >
                  <div class="cartitem">
                    日均变化比例：
                    <span> {{ slopobj["daily_percent_%"] }}%</span>
                  </div>
                  <div class="lin"></div>
                  <div class="cartitem">
                    变化显著性(0-1)：
                    <span> {{ slopobj.p_value }}</span>
                  </div>
                  <div class="lin"></div>
                  <div class="cartitem">
                    趋势：
                    <span>
                      {{
                        slopobj.trend == "increasing"
                          ? "上升"
                          : slopobj.trend == "decreasing"
                          ? "下降"
                          : "无"
                      }}</span
                    >
                  </div>
                </div>
                <template>
                  <div
                    class="righ-btn pot"
                    :class="{
                      'btn-click': btns.monotonicity,
                      'no-opt':
                        datastacsbo ||
                        banbtnbo > 1 ||
                        !isbtn.isMonotonicity ||
                        contrastbo ||ccstataShow,
                    }"
                  >
                    <div
                      class="u-flex btn-marin"
                      :class="{
                        'no-vents':
                          datastacsbo ||
                          banbtnbo > 1 ||
                          !isbtn.isMonotonicity ||
                          contrastbo ||ccstataShow,
                      }"
                      @click="setMonotonicity(isbtn.monotonicity)"
                    >
                      <img
                        src="@/assets/images/bdbj-icon.png"
                        width="12px"
                        height="12px"
                        style="margin-right: 4px"
                      />
                      单调性
                    </div>
                  </div>
                </template>
              </div>
              <template>
                <div
                  class="righ-btn pot"
                  :class="{
                    'btn-click': btns.fluctuate,
                    'no-opt': !isbtn.isFinite || banbtnbo > 1 || datastacsbo||ccstataShow,
                  }"
                >
                  <div
                    class="u-flex btn-marin"
                    @click="setnewMaxWave(!isbtn.isFinite)"
                    :class="{
                      'no-vents':
                        !isbtn.isFinite || banbtnbo > 1 || datastacsbo||ccstataShow,
                    }"
                  >
                    <img
                      src="@/assets/images/bdbj-icon.png"
                      width="12px"
                      height="12px"
                      style="margin-right: 4px"
                    />
                    波动/变点
                  </div>
                </div>
              </template>
              <template>
                <div
                  class="righ-btn pot"
                  :class="{
                    'btn-click': btns.threshold,
                    'no-opt': isbbtn || contrastbo || datastacsbo||ccstataShow,
                  }"
                >
                  <div
                    class="u-flex btn-marin"
                    @click="isShildmth(!isbtn.isFinite)"
                    :class="{
                      'no-vents': isbbtn || contrastbo || datastacsbo||ccstataShow,
                    }"
                  >
                    <img
                      src="@/assets/images/bdbj-icon.png"
                      width="12px"
                      height="12px"
                      style="margin-right: 4px"
                    />
                    阈值
                  </div>
                </div>
              </template>
            </template>

            <Dropdown>
              <div
                class="righ-btn pot"
                :class="{
                  'btn-click': btns.ledger,
                  'no-opt': contrastbo || datastacsbo||ccstataShow,
                }"
              >
                <div
                  @click.stop="drwockar()"
                  class="u-flex btn-marin"
                  :class="{
                    'no-vents': contrastbo || datastacsbo||ccstataShow,
                  }"
                >
                  <img
                    src="@/assets/images/taiz.png"
                    width="14px"
                    height="12px"
                    style="margin-right: 4px"
                  />
                  {{ tztim }}
                  <Icon type="ios-arrow-down" />
                </div>
              </div>
              <DropdownMenu slot="list" v-if="!contrastbo && !datastacsbo">
                <a
                  href="javascript:;"
                  @click="drowmeth(vol)"
                  v-for="(vol, key) in tatusoption"
                  :key="key"
                >
                  <DropdownItem>
                    {{ vol.describe }}
                  </DropdownItem>
                </a>
              </DropdownMenu>
            </Dropdown>
            <div class="righ-btn pot btn-marin" @click="resetting('chongzhi')">
              重置
            </div>
          </div>
        </div>
      </template>
    </template>
    <chartRuler
      @change="rulemethods"
      :coruleobj="coruleobj"
      v-model="rulesopen"
    />
  </div>
</template>
<script>
import * as Echarts from "echarts";
import Cselcet from "@/components/c-selectok/index";
import { accountstatus } from "@/api/pubrequst.js";
import chartRuler from "./chart-ruler";
import moment from "moment";
import tz from "../mixin/taizhang";
import Statticdro from "./statticdro-model.vue";
import CDate from "@/components/c-Date/index.vue";
export default {
  mixins: [tz],
  components: {
    Cselcet,
    chartRuler,
    Statticdro,
    CDate,
  },
  name: "redatalChaat",
  props: {
    oilSiteModelVOList: {
      type: Array,
    },
    char: {
      type: Object,
    },
    index: {
      type: [String, Number],
      default: 0,
    },
    juearr: {
      type: Array,
      default: () => [],
    },
    oilSiteId: {},
    authority: {},
    iotProductKey: {},
    iotDeviceName: {},
  },
  data() {
    return {};
  },
  created() {
    if (this.getauthoritybo) {
      this.init();
    }
  },
  mounted() {
    this.moinit();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getContainerkWidth);
  },
  methods: {
    emit() {
      this.$emit("getoption", this.myChart.getOption());
    },

    async init() {
      // let data0 = this.gettimer(6, 0);
      let data1 = this.gettimer1(6, 0);
     

      this.chartForm.date = [
        moment(data1.startDateTime).format("YYYY-M-D H:mm"),
        moment(data1.endDateTime).format("YYYY-M-D H:mm"),
      ];

      this.FormData.text = `
      <div class="u-flex">
        <div  class="right-4">统计维度: <span style="font-weight:bold">5分钟 |  </span></div>
         
        <div  class="right-4"> 统计方式: <span style="font-weight:bold">原始值 | </span></div>
              <div class=""right-4">统计周期: <span style="font-weight:bold">${moment(
                data1.startDateTime
              ).format(
                "YYYY-MM-DD"
              )} <span style="margin: 0 2px" >-</span> ${moment(
        data1.endDateTime
      ).format("YYYY-MM-DD")}</span></div>
        </div>
  
       </div> `;

      this.chatsList = this.oilSiteModelVOList.map((item) => {
        return {
          value: item.identifier,
          label: item.name,
        };
      });
      const { startDateTime, endDateTime } = data1;
      const { oilSiteIotName, oilSiteTypeId } = this.char;
      this.timeObj = {
        startDateTime,
        endDateTime,
      };
      if (this.chatsList.length > 0) {
        this.list = [this.chatsList[0].value];
      } else {
        myChart = Echarts.init(
          document.getElementById(`rhdetiChat${this.index}`),
          "light"
        );
        this.myChart = myChart;
        this.showemit();
      }

      this.banbtnbo = this.list.length;
      if (this.list.length == 1) {
        this.isbtn = this.arrishow(this.chatsList[0].label);
      }
      let data = await accountstatus();

      this.tatusoption = data.data;
      this.$nextTick(() => {
        this.list.forEach((e) => {
          this.beforehand(e);
        });
      });
    },
  },
};
</script>
<style lang="less">
@import "../css/charts.css";

.redetail-char .ivu-tag .ivu-icon {
  display: none;
}

.redetail-char .ivu-tag .ivu-tag-text {
  margin-right: 0 !important;
}

.redetail-char .ivu-select-dropdown {
  overflow: auto;
}
</style>
<style scoped lang="less">
.rehtchats-title {
  font-size: 24px;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.851);
  margin-bottom: 25px;
}

.chart-left {
  font-size: 12px;
  font-weight: 400;
  color: #555555;
  margin-right: 10px;
  white-space: nowrap;
}

.rhdetiChat {
  width: 100%;
  height: 312px;
  position: relative;
}

.right-btns {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ban-btn {
  cursor: no-drop;
}

h3.title {
  font-size: 18px;
  color: #000;
  margin: 10px 0 20px;
}

.axis-tip {
  display: none;
  position: absolute;
  padding: 5px 5px;
  font-size: 12px;
  line-height: 18px;
  color: #575757;
  background: #ffffff;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.axis-btns {
  position: absolute;

  top: 13px;
  z-index: 100;
  display: flex;

  .axis-btn {
    position: absolute;
  }
}

.newRadio {
  position: relative;

  .ridos {
    width: 90px;
    height: 22px;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    z-index: 100;
  }
}

.dis-btn {
  cursor: not-allowed !important;
  color: #c5c8ce !important;
  background-color: #f7f7f7 !important;
  border-color: #dcdee2 !important;
  pointer-events: none;
}
.shar-card {
  padding: 8px 20px;
  background: #f0f8ff;
  box-shadow: 0px 4px 10px 1px rgba(0, 0, 0, 0.1);
  border-radius: 16px 16px 16px 16px;
  opacity: 1;
  font-size: 12px;
  display: flex;
  align-items: center;
  .cartitem {
    color: rgba(0, 0, 0, 0.45);

    span {
      color: #000000;
    }
  }
  .lin {
    width: 1px;
    height: 12px;
    background: #4e4d4d73;
    margin: 0 10px;
  }
}
.blur {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.73) 32%,
    #ffffff 100%
  );
  .emtifont {
    font-size: 16px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-left: 3px;
  }
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

.blurback {
  filter: blur(4px);
  //ss
}
</style>